<template><div>

    <section class="hero is-fullheight is-primary">
        <div class="hero-body">
            <div class="container" >
                <div class='columns is-centered'>
                    <div class='column has-text-centered' >                      
                      <table class="table">
                        <thead></thead>
                        <tfoot></tfoot>
                        <tbody>
                          <tr class="is-selected is-size-4" v-for='(i, index) in zh_only(contents.project_data)' :key="index">
                            <th>{{index + 1}}</th>
                            <td class="">
                              <!-- <md :source='i.header.title'></md> -->
                              <a :href=get_anchor(i.meta.title)> {{i.meta.title}}</a>
                              </td>
                            <!-- <td><a :href=get_anchor(i.header.title)> ... </a></td> -->
                            <td>
                              <div class="tags has-addons is-size-6">
                                <span class="tag">{{i.meta.at}}</span>
                                <span class="tag is-danger" v-for='(k, count) in i.meta.tags' :key='k+count'>{{k}}</span>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                    </div>
                </div>
            </div>
        </div>
    </section>

</div></template>

<script>
import md from "../components/mdify.vue";

export default {
  data() {
    return {
    };
  },
  methods: {
    zh_only: function(items) {
      return items;
      const temp = items.slice(); //copy to evade infinite loop, see https://github.com/vuejs/vue/issues/1153
        return temp.filter(function(item) {
          return item.header.language == 'zh';
        });
    },
    get_anchor(i)
    {
      return 'https://tan.netlify.app/?src=projects-zh&loc=zh' + this.contents.toc_data[i];
    }
  },
  props: ["contents"],

  components: {
    md
  }
};
</script>




// WEBPACK FOOTER //
// src/components/landing_table.vue